function paramsSerializer(params) {
    return new URLSearchParams(params).toString();
}
export function mergeHeaders(header, header2) {
    const base = new Headers(header);
    new Headers(header2).forEach((value, key) => {
        base.set(key, value);
    });
    return base;
}
export const WITHOUT_BODY_METHODS = ['GET', 'HEAD', 'OPTIONS', 'CONNECT', 'TRACE'];
export const WITH_BODY_METHODS = ['DELETE', 'PATCH', 'POST', 'PUT'];
export class FetchHelper {
    defaultInit;
    constructor(fetchConfig) {
        this.defaultInit = fetchConfig || {};
    }
    async request(input, init) {
        const mergeInit = { ...this.defaultInit, ...init, headers: mergeHeaders(this.defaultInit?.headers, init?.headers) };
        init = mergeInit.transformRequest ? await mergeInit.transformRequest({ init: mergeInit, input, ctx: this }) : mergeInit;
        if (typeof input === 'string') {
            const inputURL = new URL(input, init.baseURL);
            const queryString = (init.paramsSerializer || paramsSerializer)(init.params);
            if (queryString) {
                input = `${inputURL.href}${inputURL.search ? '&' : '?'}${queryString}`;
            }
            else {
                input = inputURL.href;
            }
        }
        let response;
        let error;
        try {
            response = await (init.adapter || fetch)(input, init);
            if (init.handlerSuccess) {
                init?.handlerSuccess(response);
            }
        }
        catch (e) {
            error = e;
            if (init.handlerError) {
                init?.handlerError(error);
            }
            else {
                throw error;
            }
        }
        finally {
            // eslint-disable-next-line no-unsafe-finally
            return mergeInit.transformResponse ? mergeInit.transformResponse({ response, error, init, input, ctx: this }) : response;
        }
    }
}
